import { UIElement } from '../ui-element.js';
import styles from '../divider/ui-divider.css';

/**
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDivider
 * @element ui-divider
 * @classdesc Represents a class for <code>ui-divider</code> element.
 * @example
 * <ui-divider></ui-divider>
 */
class UIDivider extends UIElement {
    /**
     * @inheritDoc
     */
    render() {
        this.append(document.createElement('span'));
    }
}

UIDivider.defineElement('ui-divider', styles);
export { UIDivider };
